import { render, staticRenderFns } from "./SendInvitations.vue?vue&type=template&id=09d11dd6&scoped=true&"
import script from "./SendInvitations.vue?vue&type=script&lang=js&"
export * from "./SendInvitations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09d11dd6",
  null
  
)

export default component.exports